import { MapContentLayer } from '../MapContentLayer';
import { CircleLayerSpecification, LayerSpecification } from 'maplibre-gl';
import { MapContentSource } from '../MapContentSource';
import { MapStyles } from '../../../../../configuration/map-styles';

export class ShiftMarkerCircleLayer extends MapContentLayer {

  constructor(
    source: MapContentSource
  ) {
    super('shift-marker-circle-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'circle',
      source: this.sourceRef.sourceId,
      layout: {
        'circle-sort-key': [
          'case',
          ['boolean', ['get', 'vehicle']],
          3,
          [
            'case',
            ['boolean', ['get', 'start']],
            2,
            1,
          ]
        ],
      },
      paint: {
        'circle-color': [
          'case',
          ['boolean', ['get', 'vehicle']],
          '#fff6dc',
          '#FEFEFE',
        ],
        'circle-radius': [
          'case',
          ['boolean', ['get', 'vehicle']],
          13,
          15,
        ],
        'circle-opacity': 1.0,
        'circle-stroke-width': [
          'case',
          ['boolean', ['get', 'vehicle']],
          2,
          0,
        ],
        'circle-stroke-color': MapStyles.PAUSED_COLOR,
      },
      visibility: 'visible'
    } as CircleLayerSpecification;
  }

}
